// gallery-badge.component.ts
import { Component, ChangeDetectionStrategy, Input } from "@angular/core";
import { TEMPLATE_GALLERY_URL } from "../../views/string-constants";

/**
 * One-line badge, always backed by a Notion gallery link. Two different listings, never mixed:
 * - `kind="integration"` (default): "Official Notion integration" linking the OAuth
 *   integration listing notion.com/connections/nh2 (Notion reviewed the app).
 * - `kind="template"`: "Free Notion template" linking the Marketplace template listing
 *   (`TEMPLATE_GALLERY_URL`, notion.com/templates/habitheroes).
 */
@Component({
  selector: "app-gallery-badge",
  templateUrl: "./gallery-badge.component.html",
  styleUrls: ["./gallery-badge.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class GalleryBadgeComponent {
  /** "onDark" for placement on the purple hero background. */
  @Input() tone: "default" | "onDark" = "default";
  /** "start" follows the parent's text alignment instead of centring. */
  @Input() align: "center" | "start" = "center";
  /** Which Notion listing the badge advertises. */
  @Input() kind: "integration" | "template" = "integration";

  readonly templateGalleryUrl = TEMPLATE_GALLERY_URL;
}
